import { render, staticRenderFns } from "./parts_detail.vue?vue&type=template&id=1ce5113c&scoped=true&"
import script from "./parts_detail.vue?vue&type=script&lang=js&"
export * from "./parts_detail.vue?vue&type=script&lang=js&"
import style0 from "./parts_detail.vue?vue&type=style&index=0&id=1ce5113c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce5113c",
  null
  
)

export default component.exports